export const addLocationSelector = state => state.addLocation;